/**
 * Province italiane escluse dalla spedizione
 */

export const SICILIAN_PROVINCES = ['AG', 'CL', 'CT', 'EN', 'ME', 'PA', 'RG', 'SR', 'TP'];

export const SARDINIAN_PROVINCES = ['CA', 'CI', 'NU', 'OR', 'SS', 'SU', 'VS', 'OG', 'OT'];

export const EXCLUDED_PROVINCES = [...SICILIAN_PROVINCES, ...SARDINIAN_PROVINCES];

export const isProvinceExcluded = (province: string): boolean => {
  if (!province) return false;
  return EXCLUDED_PROVINCES.includes(province.toUpperCase());
};

export const EXCLUDED_PROVINCE_ERROR_MESSAGE = 'Spiacenti, al momento non effettuiamo spedizioni in Sicilia e Sardegna';
